import { TailwindTextStyle as Base } from "@corca/tiptap";

import { setTableCellTextStyle } from "@/components/tiptap/tables/commands";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    color: {
      setColor: (color: string) => ReturnType;
      unsetColor: () => ReturnType;
    };
    size: {
      setFontSize: (size: string) => ReturnType;
      unsetFontSize: () => ReturnType;
    };
  }
}

export const TailwindTextStyle = Base.extend({
  addCommands() {
    return {
      setColor: (color) => (props) => {
        if (setTableCellTextStyle({ color })(props)) {
          return true;
        }
        return props.chain().setMark("textStyle", { color }).run();
      },
      unsetColor:
        () =>
        ({ chain }) => {
          return chain().setMark("textStyle", { color: null }).run();
        },
      setFontSize: (size) => (props) => {
        if (setTableCellTextStyle({ size })(props)) {
          return true;
        }
        return props.chain().setMark("textStyle", { size }).run();
      },
      unsetFontSize:
        () =>
        ({ chain }) => {
          return chain().setMark("textStyle", { size: null }).run();
        },
    };
  },
});
